import { render, staticRenderFns } from "./EditTaxAmount.vue?vue&type=template&id=1c0fa961&"
import script from "./EditTaxAmount.vue?vue&type=script&lang=js&"
export * from "./EditTaxAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports